document.addEventListener("DOMContentLoaded", (event) => {

  var form = $('form.js-aspnet-form');

  var countrySelect = form.find("select.Country");
  countrySelect.change(function() {
      vaneck.membership.countrySelectChanged($(this));
      var parentForm = $(this).parents("form.js-aspnet-form");
      epi.EPiServer.Forms.forceValidationOnChange(parentForm, 'State');
  });
    vaneck.membership.countrySelectChanged(countrySelect);

});
